module.exports = __webpack_public_path__ + "img/g_bg1.db49b62d.jpg";